interface Props {
    textDark: boolean;
    bookStoreRazorPayMode: boolean;
}

const Footer = ({ textDark, bookStoreRazorPayMode }: Props) => {
    return (
        <div className={`pb-4 pl-3 text-center ${textDark ? 'text-white-dark' : 'text-white'} ltr:sm:text-left rtl:sm:text-right`}>
            © {new Date().getFullYear()}. {bookStoreRazorPayMode ? 'Bookshelf' : 'Hepta Infotech Services LLP'} All rights reserved.
        </div>
    );
};

export default Footer;
